export default function umeSlidersInit() {
    const sliders = document.querySelectorAll('.ume-event-slider');
    if (sliders) {
        let temp_array = [],
            length = sliders.length;

        for (let i = 0; i < length; i++) {
            temp_array.push(sliders[i]);
        }
        temp_array.forEach(slider => {
            const slides = slider.querySelectorAll('.ume-event-slide');
            for (let i = 0; i < slides.length; i++) {

                let next = slides[i].querySelectorAll('.ume-event-slider-next');
                let prev = slides[i].querySelectorAll('.ume-event-slider-prev');

                if (slides.length > 1) {
                    next[0].addEventListener('click', () => {
                        if (slides[i] && slides[i + 1]) {
                            slides[i].classList.toggle('ume-event-slide__show');
                            slides[i + 1].classList.toggle('ume-event-slide__show');
                        }

                    })
                    prev[0].addEventListener('click', () => {
                        if (slides[i] && slides[i - 1]) {
                            slides[i].classList.toggle('ume-event-slide__show');
                            slides[i - 1].classList.toggle('ume-event-slide__show');
                        }
                    })
                }
            }
        })
    }
}
